import { FormEvent, useState } from 'react'
import style from './login.module.scss'
import { Navigate, useLocation, useNavigate } from 'react-router'
import { useGetLoginMutation } from 'src/redux/Api/authApi'
import { useDispatch } from 'react-redux'
import { setCredentials } from 'src/redux/Slices/authSlice'
import { useAuth } from 'src/utils/Hooks/useAuth'
import { setParams } from 'src/redux/Slices/configSlice'
import Input from 'src/Components/Form/Input'
import { useCheckForm } from 'src/utils/Hooks/useCheckForm'
import GoogleAuth from 'src/Components/GoogleAuth'

const Login = () => {
  const checkForm = useCheckForm()
  const dispatch = useDispatch()
  const { id } = useAuth()
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const location = useLocation()
  const navigate = useNavigate()
  const prev = location.state?.from?.pathname || '/'
  const [login] = useGetLoginMutation()

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const check = checkForm(e)
    try {
      if (check) {
        const result = await login({ email, password }).unwrap()
        dispatch(setCredentials(result.data))
        navigate(prev, { replace: true })
      } else {
        dispatch(setParams({ status: 'warning', message: 'Fill in required fields' }))
      }
    } catch (e) {
      dispatch(setParams({ status: 'error', message: 'Invalid email or password' }))
    }
  }

  return id ? (
    <Navigate to="/" replace={true} />
  ) : (
    <>
      <h1 className="main_title">Login</h1>
      <section className={style.login}>
        <form className="block" onSubmit={handleSubmit}>
          <Input
            onChange={(e) => {
              setEmail(e.target.value)
            }}
            type="email"
            name="email"
            label="Email"
            required
            value={email}
          />
          <Input
            onChange={(e) => {
              setPassword(e.target.value)
            }}
            type="password"
            name="pwd"
            label="Password"
            required
            value={password}
          />
          <button className="btn" type="submit">
            Login
          </button>
          <GoogleAuth />
        </form>
      </section>
    </>
  )
}

export default Login
